module.exports = __webpack_public_path__ + "static/media/optimizacion_bco.4800c8ef.svg";